import Image from "next/image";
import Link from "next/link";

import copusLogo from "@/assets/images/copus-logo.png";
import { cn } from "@/helpers/className";
import { useTranslation } from "@/i18n/client";
import { AllowedLanguages } from "@/types/generic";

interface FooterLoginSectionProps {
  className?: string;
  locale: AllowedLanguages;
}

export const FooterCopusLogo = ({
  className,
  locale,
}: FooterLoginSectionProps) => {
  const { t } = useTranslation(locale);
  return (
    <div className={cn("flex flex-col gap-2", className)}>
      <div className="flex flex-row items-baseline gap-3">
        <span className="text-lg font-bold text-gray-900">
          {t("components.footer_copus_logo.part_of")}
        </span>
        <Link href="https://copus.group/" target="_blank">
          <Image
            src={copusLogo}
            width={155}
            height={30}
            alt={t("components.footer_copus_logo.logo_alt")}
            className="w-[155px]"
          />
        </Link>
      </div>

      <div className="text-black-400">
        {t("components.footer_copus_logo.brand_slogan")}
      </div>
    </div>
  );
};
